// The renderer must be loaded first for the @ViewChild in the chart
export * from './jobs-gantt-chart-renderer.component';
export * from './jobs-gantt-chart.component';
